<app-certificate-navbar></app-certificate-navbar>
<app-breadcrumb style="display: flex; padding-left: 28px"></app-breadcrumb>
<div class="container">
  <router-outlet></router-outlet>
</div>
